module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"show_announcement_modal","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"label":{"type":"string"}},"required":["user","label"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/show_announcement_modal.json
// module id = 572
// module chunks = 97